import React, { lazy } from 'react';

const PersonalDetails = lazy(
  () => import(/* webpackChunkName: "carvana-purchase-personal-details-ds" */ './personal-details')
);

export const PersonalDetailsRoute = () => {
  return <PersonalDetails />;
};
